import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'

import images from '../images'

const Inner = ({ item }) => (
    <div className="flex flex-grow">
        {item.icon}
        <span className="text-sm font-medium">{item.name}</span>
    </div>
)

function Sidebar({
    sidebarOpen,
    setSidebarOpen
}) {

    const location = useLocation()
    const split = location.pathname.split('/')
    const page = split[2]

    const { user } = useSelector(state => state.application)

    const subpage = split.length > 3 ? split[3] : null

    const trigger = useRef(null)
    const sidebar = useRef(null)

    let menu = [
        {
            name: 'Sales',
            to: 'sales',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <circle className={`fill-current text-gray-400 ${page === 'sales' && 'text-indigo-300'}`} cx="18.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'sales' && 'text-indigo-500'}`} cx="5.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'sales' && 'text-indigo-500'}`} cx="18.5" cy="18.5" r="4.5" />
                <circle className={`fill-current text-gray-400 ${page === 'sales' && 'text-indigo-300'}`} cx="5.5" cy="18.5" r="4.5" />
            </svg>
        },
        {
            name: 'Transactions',
            to: 'transactions',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <circle className={`fill-current text-gray-400 ${page === 'transactions' && 'text-indigo-300'}`} cx="18.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'transactions' && 'text-indigo-500'}`} cx="5.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'transactions' && 'text-indigo-500'}`} cx="18.5" cy="18.5" r="4.5" />
                <circle className={`fill-current text-gray-400 ${page === 'transactions' && 'text-indigo-300'}`} cx="5.5" cy="18.5" r="4.5" />
            </svg>
        },
        {
            name: 'Sale Items',
            to: 'saleitems',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <circle className={`fill-current text-gray-400 ${page === 'saleitems' && 'text-indigo-300'}`} cx="18.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'saleitems' && 'text-indigo-500'}`} cx="5.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'saleitems' && 'text-indigo-500'}`} cx="18.5" cy="18.5" r="4.5" />
                <circle className={`fill-current text-gray-400 ${page === 'saleitems' && 'text-indigo-300'}`} cx="5.5" cy="18.5" r="4.5" />
            </svg>
        },
        {
            name: 'Inventory',
            to: 'inventory',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-400 ${page === 'inventory' && 'text-indigo-300'}`} d="M13 15l11-7L11.504.136a1 1 0 00-1.019.007L0 7l13 8z" />
                <path className={`fill-current text-gray-700 ${page === 'inventory' && 'text-indigo-600'}`} d="M13 15L0 7v9c0 .355.189.685.496.864L13 24v-9z" />
                <path className={`fill-current text-gray-600 ${page === 'inventory' && 'text-indigo-500'}`} d="M13 15.047V24l10.573-7.181A.999.999 0 0024 16V8l-11 7.047z" />
            </svg>
        },
        {
            name: 'Bills',
            to: 'bills',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-400 ${page === 'bills' && 'text-indigo-300'}`} d="M13 15l11-7L11.504.136a1 1 0 00-1.019.007L0 7l13 8z" />
                <path className={`fill-current text-gray-700 ${page === 'bills' && 'text-indigo-600'}`} d="M13 15L0 7v9c0 .355.189.685.496.864L13 24v-9z" />
                <path className={`fill-current text-gray-600 ${page === 'bills' && 'text-indigo-500'}`} d="M13 15.047V24l10.573-7.181A.999.999 0 0024 16V8l-11 7.047z" />
            </svg>
        },
        {
            name: 'Rooms',
            to: 'rooms',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <circle className={`fill-current text-gray-400 ${page === 'rooms' && 'text-indigo-300'}`} cx="18.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'rooms' && 'text-indigo-500'}`} cx="5.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'rooms' && 'text-indigo-500'}`} cx="18.5" cy="18.5" r="4.5" />
                <circle className={`fill-current text-gray-400 ${page === 'rooms' && 'text-indigo-300'}`} cx="5.5" cy="18.5" r="4.5" />
            </svg>
        },
        {
            name: 'Tables',
            to: 'tables',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-400 ${page === 'tables' && 'text-indigo-500'}`} d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z" />
                <path className={`fill-current text-gray-600 ${page === 'tables' && 'text-indigo-600'}`} d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z" />
                <path className={`fill-current text-gray-400 ${page === 'tables' && 'text-indigo-200'}`} d="M12 15c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L6 6l4.714 3.301A2.973 2.973 0 0112 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z" />
            </svg>
        },
        {
            name: 'Invoices',
            to: 'invoices',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <circle className={`fill-current text-gray-400 ${page === 'invoices' && 'text-indigo-300'}`} cx="18.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'invoices' && 'text-indigo-500'}`} cx="5.5" cy="5.5" r="4.5" />
                <circle className={`fill-current text-gray-600 ${page === 'invoices' && 'text-indigo-500'}`} cx="18.5" cy="18.5" r="4.5" />
                <circle className={`fill-current text-gray-400 ${page === 'invoices' && 'text-indigo-300'}`} cx="5.5" cy="18.5" r="4.5" />
            </svg>
        },
        {
            name: 'Received Invoices',
            to: 'received-invoices',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-600 ${page === 'received-invoices' && 'text-indigo-500'}`} d="M8 1v2H3v19h18V3h-5V1h7v23H1V1z" />
                <path className={`fill-current text-gray-600 ${page === 'received-invoices' && 'text-indigo-500'}`} d="M1 1h22v23H1z" />
                <path className={`fill-current text-gray-400 ${page === 'received-invoices' && 'text-indigo-300'}`} d="M15 10.586L16.414 12 11 17.414 7.586 14 9 12.586l2 2zM5 0h14v4H5z" />
            </svg>
        },
        {
            name: 'Purchase Orders',
            to: 'lpos',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-400 ${page === 'lpos' && 'text-indigo-500'}`} d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z" />
                <path className={`fill-current text-gray-600 ${page === 'lpos' && 'text-indigo-600'}`} d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z" />
                <path className={`fill-current text-gray-400 ${page === 'lpos' && 'text-indigo-200'}`} d="M12 15c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L6 6l4.714 3.301A2.973 2.973 0 0112 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z" />
            </svg>
        },
        {
            name: 'Users',
            to: 'users',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-600 ${page === 'users' && 'text-indigo-500'}`} d="M18.974 8H22a2 2 0 012 2v6h-2v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5h-2v-6a2 2 0 012-2h.974zM20 7a2 2 0 11-.001-3.999A2 2 0 0120 7zM2.974 8H6a2 2 0 012 2v6H6v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5H0v-6a2 2 0 012-2h.974zM4 7a2 2 0 11-.001-3.999A2 2 0 014 7z" />
                <path className={`fill-current text-gray-400 ${page === 'users' && 'text-indigo-300'}`} d="M12 6a3 3 0 110-6 3 3 0 010 6zm2 18h-4a1 1 0 01-1-1v-6H6v-6a3 3 0 013-3h6a3 3 0 013 3v6h-3v6a1 1 0 01-1 1z" />
            </svg>
        },
        {
            name: 'Item Groups',
            to: 'item-groups',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-400 ${page === 'item-groups' && 'text-indigo-500'}`} d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z" />
                <path className={`fill-current text-gray-600 ${page === 'item-groups' && 'text-indigo-600'}`} d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z" />
                <path className={`fill-current text-gray-400 ${page === 'item-groups' && 'text-indigo-200'}`} d="M12 15c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L6 6l4.714 3.301A2.973 2.973 0 0112 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z" />
            </svg>
        },
        {
            name: 'Printers',
            to: 'printers',
            icon: <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                <path className={`fill-current text-gray-400 ${page === 'printers' && 'text-indigo-500'}`} d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z" />
                <path className={`fill-current text-gray-600 ${page === 'printers' && 'text-indigo-600'}`} d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z" />
                <path className={`fill-current text-gray-400 ${page === 'printers' && 'text-indigo-200'}`} d="M12 15c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L6 6l4.714 3.301A2.973 2.973 0 0112 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z" />
            </svg>
        }
    ]

    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (!sidebar.current || !trigger.current) return
            if (!sidebarOpen || sidebar.current.contains(target) || trigger.current.contains(target)) return
            setSidebarOpen(false)
        }
        document.addEventListener('click', clickHandler)
        return () => document.removeEventListener('click', clickHandler)
    })

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }) => {
            if (!sidebarOpen || keyCode !== 27) return
            setSidebarOpen(false)
        }
        document.addEventListener('keydown', keyHandler)
        return () => document.removeEventListener('keydown', keyHandler)
    })

    return (
        <div className="lg:w-64">
            {/* Sidebar backdrop (mobile only) */}
            <div className={`fixed inset-0 bg-gray-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} aria-hidden="true"></div>

            {/* Sidebar */}
            <div
                id="sidebar"
                ref={sidebar}
                className={`absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 transform h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 flex-shrink-0 bg-gray-800 p-4 transition-transform duration-200 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-64'}`}
            >

                {/* Sidebar header */}
                <div className="flex lg:justify-center mb-10 pr-3 sm:px-2">
                    {/* Close button */}
                    <button
                        ref={trigger}
                        className="lg:hidden text-gray-500 hover:text-gray-400"
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        aria-controls="sidebar"
                        aria-expanded={sidebarOpen}
                    >
                        <span className="sr-only">Close sidebar</span>
                        <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
                        </svg>
                    </button>
                    {/* Logo */}
                    <img src={images.logoLight} className="w-28 self-center sidebar-logo" />
                    {/* <svg width="32" height="32" viewBox="0 0 32 32">
                        <defs>
                            <linearGradient x1="28.538%" y1="20.229%" x2="100%" y2="108.156%" id="logo-a">
                                <stop stopColor="#A5B4FC" stopOpacity="0" offset="0%" />
                                <stop stopColor="#A5B4FC" offset="100%" />
                            </linearGradient>
                            <linearGradient x1="88.638%" y1="29.267%" x2="22.42%" y2="100%" id="logo-b">
                                <stop stopColor="#38BDF8" stopOpacity="0" offset="0%" />
                                <stop stopColor="#38BDF8" offset="100%" />
                            </linearGradient>
                        </defs>
                        <rect fill="#6366F1" width="32" height="32" rx="16" />
                        <path d="M18.277.16C26.035 1.267 32 7.938 32 16c0 8.837-7.163 16-16 16a15.937 15.937 0 01-10.426-3.863L18.277.161z" fill="#4F46E5" />
                        <path d="M7.404 2.503l18.339 26.19A15.93 15.93 0 0116 32C7.163 32 0 24.837 0 16 0 10.327 2.952 5.344 7.404 2.503z" fill="url(#logo-a)" />
                        <path d="M2.223 24.14L29.777 7.86A15.926 15.926 0 0132 16c0 8.837-7.163 16-16 16-5.864 0-10.991-3.154-13.777-7.86z" fill="url(#logo-b)" />
                    </svg> */}
                </div>

                {/* Links */}
                <div>
                    <h3 className="text-xs uppercase text-gray-500 font-semibold pl-3">Menu</h3>
                    <ul className="mt-3">
                        {
                            menu
                                .filter(item => {
                                    if (user.name === 'Root')
                                        return true

                                    let routes = user.stations.find(st => st.name === 'routes')

                                    if (!routes)
                                        return false

                                    return routes.permissions.includes(item.to)                                    
                                })
                                .map(item =>
                                    <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${page === item.to && 'bg-gray-900'}`}>
                                        <NavLink exact to={`/app/${item.to}`} className={`block text-gray-200 hover:text-white transition duration-150 ${page === item.name.toLowerCase() && 'hover:text-gray-200'}`}>
                                            {
                                                item.submenu ?
                                                    <div className="flex items-center justify-between">
                                                        <Inner item={item} />
                                                        <div className="flex flex-shrink-0 ml-2">
                                                            <svg className={`w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400 ${page === item.name.toLowerCase() && 'transform rotate-180'}`} viewBox="0 0 12 12">
                                                                <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    : <Inner item={item} />
                                            }
                                        </NavLink>
                                        {
                                            item.submenu &&
                                            <ul className={`pl-9 mt-1 ${page !== item.name.toLowerCase() ? 'hidden' : ''}`}>
                                                {
                                                    item.submenu?.map(itm =>
                                                        <li className="mt-3 mb-1 last:mb-3">
                                                            <NavLink exact to={`/app/${item.to}/${itm.to}`} className={`block text-gray-200 hover:text-white transition duration-150 ${subpage === 'team-tabs' && 'text-indigo-400 hover:text-indigo-400'}`}>
                                                                <span className="text-sm font-medium">{itm.name}</span>
                                                            </NavLink>
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                        }

                                    </li>
                                )
                        }
                    </ul>
                </div>

            </div>
        </div>
    )
}

export default Sidebar